export interface SortableConfig {
    list: HTMLElement;
    template: (el: HTMLElement, i: number) => string;
    storage?: HTMLInputElement;
}

export class Sortable {
    private readonly elements: {
        list: HTMLElement;
        items: HTMLCollection;
        storage: HTMLInputElement;
    };
    protected template: (el: HTMLElement, i: number) => string;

    constructor({list, template, storage}: SortableConfig) {
        this.elements = {
            list,
            items: list.children,
            storage: storage
                ? storage
                : list.previousElementSibling as HTMLInputElement
        };
        this.template = template;
        this.bind();
    }

    protected static getNextElement(cursorPosition: number, target: HTMLElement): Element {
        const currentElementCoord = target.getBoundingClientRect();
        const currentElementCenter = currentElementCoord.y + currentElementCoord.height / 2;
        return (cursorPosition < currentElementCenter)
            ? target
            : target.nextElementSibling;
    };

    protected static onDragsStart(evt: MouseEvent): void {
        const target = evt.target as HTMLElement;
        target.classList.add(`is-selected`);
    }

    protected onCheckbox(item: Element, checkbox: Element): void {
        const enable = item.getAttribute(`data-enable`) === `true`
            ? `false`
            : `true`;
        item.setAttribute(`data-enable`, enable);
        this.save();
    }

    protected onDragOver(evt: MouseEvent): void {
        evt.preventDefault();

        const {list, items} = this.elements;
        const target = evt.target as HTMLElement;
        const current = Array.from(items).find(item => item.matches(`.is-selected`));
        const isMoveable = current !== target && target.parentElement === list;
        if (!isMoveable) return;

        const next = Sortable.getNextElement(evt.clientY, target);
        if (next && current === next.previousElementSibling || current === next ) return;
        list.insertBefore(current, next);
    }

    protected onDragEnd(evt: MouseEvent): void {
        const target = evt.target as HTMLElement;
        target.classList.remove(`is-selected`);
        this.save();
    }

    protected save(): void {
        const {items, storage} = this.elements;

        let data = `{`;
        [...items].forEach((item: HTMLElement, key: number) => data += this.template(item, key));
        data = data.replace(/.$/,"}");
        data = data.replace(/\s{2,}/g, '');
        storage.value = data;
    }

    protected bind(): void {
        const list = this.elements.list;

        list.addEventListener('dragstart', (evt) => Sortable.onDragsStart(evt));
        list.addEventListener('dragover', (evt) => this.onDragOver(evt));
        list.addEventListener('dragend', (evt) => this.onDragEnd(evt));
        [...this.elements.items].forEach((item: HTMLElement) => {
            const checkbox = item.querySelector(`input[type=checkbox]`);
            if (checkbox) checkbox.addEventListener('change', () => this.onCheckbox(item, checkbox));
            item.draggable = true;
        });
    }
}